<template>
  <v-container>
    <v-row dense>
      <v-col v-for="item in items" :key="item.id" :cols="2">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
            <v-btn outlined rounded text primary :href="item.href">
              Details
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="showExtras(item.id)">
              <v-icon>{{
                show && showId == item.id
                  ? "mdi-chevron-up"
                  : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="showId == item.id">
              <v-divider></v-divider>
              <v-card-text>
                {{ item.description }}
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Settings",
  data: () => ({
    show: false,
    showId: 0,
    items: [
      {
        id: 1,
        title: "Discounts",
        href: "/discounts",
        description:
          "Discounts registry keeps information about discounts applied for brands, conditions, categories and platforms.",
      },
      {
        id: 2,
        title: "Brands",
        href: "/brands",
        description:
          "Brands registry keeps information about all brands and their currency rates.",
      },
      {
        id: 3,
        title: "Categories",
        href: "/categories",
        description:
          "Category registry keeps information about all categories and their configuration.",
      },
      // {id: 4, title: "Materials", href: "/materials", description: "Material registry keeps information about all materials to be used in listings."},
      {
        id: 5,
        title: "Colors",
        href: "/colors",
        description:
          "Color registry keeps information about real colors and corresponding color maps to be used in listings.",
      },
      {
        id: 6,
        title: "SE locations",
        href: "/selocations",
        description:
          "SE locations registry keeps information about boxes that are used as locations to problematic items.",
      },
      {
        id: 7,
        title: "Platform mapping",
        href: "/platformMapping",
        description: "Map map map",
      },
    ],
  }),
  methods: {
    showExtras(itemId) {
      if (this.showId == itemId) {
        this.show = false;
        this.showId = 0;
      } else {
        this.showId = itemId;
        this.show = true;
      }
    },
  },
};
</script>